// import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './utils/AuthContext';

export default function RequireAuth({ children, allowedRoles }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) return <div>Loading...</div>;
    if (!user) return <Navigate to='/login' state={{ from: location }} replace />
    if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to='/403' replace />;

    return children;
}